import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export interface TextMessageTemplate {
   textMessageTemplateId: number
   name: string
   message: string
 }


/**
 * Retrieves the text message templates from the server.
 * @returns A promise that resolves to an array of TextMessageTemplate objects.
 * @throws An error if the authorization token is not found.
 */
export const getTextMessageTemplates = async (): Promise<TextMessageTemplate[]> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.get(`https://${apiURL}/TextMessageTemplate`, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });
   return response.data;
};

export const updateTextMessageTemplate = async (template: TextMessageTemplate): Promise<any> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.put(`https://${apiURL}/TextMessageTemplate/${template.textMessageTemplateId}`, template, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });
   return response.data;
};
